<app-breadcrumbs></app-breadcrumbs>
<div>
    <div id="rogue-ap-audit-wrapper">
        <div [cfaLoading]="isLoading">
            <table id="rogue-ap-audit-table" #rogueApTable mat-table matSort [dataSource]="dataSource"
                class="mat-elevation-z8" matSortActive="storeNumber" matSortDirection="asc">
                <ng-container matColumnDef="storeNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Store Number </th>
                    <td mat-cell *matCellDef="let rogueAp"> {{rogueAp.storeNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="ssid">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SSID </th>
                    <td mat-cell *matCellDef="let rogueAp"> {{rogueAp.ssid}} </td>
                </ng-container>
                <ng-container matColumnDef="mac">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> MAC </th>
                    <td mat-cell *matCellDef="let rogueAp"> {{rogueAp.mac}} </td>
                </ng-container>
                <ng-container matColumnDef="channel">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Channel </th>
                    <td mat-cell *matCellDef="let rogueAp"> {{rogueAp.channel}} </td>
                </ng-container>
                <ng-container matColumnDef="rssi">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> RSSI </th>
                    <td mat-cell *matCellDef="let rogueAp"> {{rogueAp.rssi}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>